var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((5),function(star,index){return _c('b-icon',{key:index,staticStyle:{"color":"#ffd700","width":"1em","height":"1em"},attrs:{"icon":_vm.getStarIcon(index)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }